export const config = {
  apiUrl: import.meta.env.VITE_API_URL as string | undefined,
  region: import.meta.env.VITE_AWS_REGION as string | undefined,
  userPoolId: import.meta.env.VITE_USER_POOL_ID as string | undefined,
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID as string | undefined,
  // Dominio de la web pública: por ahí se sirven las fotos con marca de agua.
  mediaBase: import.meta.env.VITE_MEDIA_BASE as string | undefined,
  /** La web pública, para los enlaces «Ver en la web». */
  webUrl: import.meta.env.VITE_WEB_URL as string | undefined,
};

export const isConfigured = Boolean(
  config.apiUrl && config.userPoolId && config.userPoolClientId && config.mediaBase,
);
